document.addEventListener("DOMContentLoaded", () => {
  const subscriptionPlanSelects =
    document.querySelectorAll(".subscription-plan") || [];

  subscriptionPlanSelects.forEach((subscriptionPlanSelect) => {
    const subscriptionPlanDropdown = subscriptionPlanSelect.nextElementSibling;
    if (!subscriptionPlanDropdown || !subscriptionPlanDropdown.classList.contains("subscription-plan-dropdown")) return;

    const subscriptionPlanButtons = subscriptionPlanDropdown.querySelectorAll("button") || [];
    const subscriptionPlanTextSpan = subscriptionPlanSelect.querySelector("span") || null;

    subscriptionPlanSelect.addEventListener("click", function (e) {
      e.stopPropagation();
      subscriptionPlanDropdown.classList.toggle("hidden");
      const isOpen = !subscriptionPlanDropdown.classList.contains("hidden");
      subscriptionPlanSelect.setAttribute("aria-expanded", isOpen ? "true" : "false");
      subscriptionPlanSelect.querySelector("svg")?.classList.toggle("rotate-180");
    });

    document.addEventListener("click", function closeDropdown(e) {
      if (
        !subscriptionPlanSelect.contains(e.target) &&
        !subscriptionPlanDropdown.contains(e.target)
      ) {
        subscriptionPlanDropdown.classList.add("hidden");
        subscriptionPlanSelect.setAttribute("aria-expanded", "false");
        subscriptionPlanSelect.querySelector("svg")?.classList.remove("rotate-180");
      }
    });

    subscriptionPlanButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const selectedId = this.value;
        const selectedText = this.textContent.trim();
        subscriptionPlanSelect.setAttribute("data-subscription-id", selectedId);
        if (subscriptionPlanTextSpan) subscriptionPlanTextSpan.textContent = selectedText;
        subscriptionPlanDropdown.classList.add("hidden");
        subscriptionPlanSelect.setAttribute("aria-expanded", "false");
        subscriptionPlanSelect.querySelector("svg")?.classList.remove("rotate-180");
      });
    });
  });

  let addToCartButtonsLanding = document.querySelectorAll(".add-to-cart-button-landing");
  addToCartButtonsLanding.forEach(function (button) {
    button.addEventListener("click", function () {
      let planId = 0;
      let productContainer = button.closest(".product");
      let selectedVariant;

      selectedVariant = productContainer.querySelector(".product-variant").value;

      if (productContainer.querySelector('input[type="radio"]:checked')) {

        let selectedRadio = productContainer.querySelector(
            'input[type="radio"]:checked'
        );

        if (selectedRadio.classList.contains("subscription")) {
          planId = productContainer
              .querySelector(".subscription-plan")
              .getAttribute("data-subscription-id");
        }
      }

      let qty = productContainer.querySelector("#quantityInput").value;
      addItemToCart(selectedVariant, qty, planId, 1);
    });
  });

  let addToCartButtons = document.querySelectorAll(".add-to-cart-button");
  addToCartButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      let planId = null;
      let productContainer = button.closest(".product");
      let selectedVariant;

      selectedVariant =
        productContainer.querySelector(".product-variant").value;

      if (productContainer.querySelector('input[type="radio"]:checked')) {
        let selectedRadio = productContainer.querySelector(
          'input[type="radio"]:checked'
        );

        if (selectedRadio.classList.contains("subscription")) {
          planId = productContainer
            .querySelector(".subscription-plan")
            .getAttribute("data-subscription-id");
        }
      }

      let qty = productContainer.querySelector("#quantityInput").value;
      const isPdpPath = /^\/products\//.test(window.location.pathname);
      const shouldDirectCheckout =
        button.dataset.directCheckout === "true" || !isPdpPath;
      addItemToCart(selectedVariant, qty, planId, shouldDirectCheckout ? 1 : 0);
    });
  });

  function addItemToCart(variant_id, qty, selling_plan, landing = 0) {
    let data = {
      id: variant_id,
      quantity: qty,
      selling_plan: selling_plan,
    };

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/add.js");
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      if (xhr.status === 200) {
          initCart();
          openCartMenu();
        // if (Number(landing) === 1) {
        //   document.location.href='/checkout';
        // } else {
        //   initCart();
        //   openCartMenu();
        // }
      } else {
        const errorResponse = JSON.parse(xhr.responseText);
        alert(errorResponse.message + "\r\n" + errorResponse.description);
      }
    };

    xhr.onerror = function (error) {
      console.error("An error occurred:", error);
    };

    xhr.send(JSON.stringify(data));
  }

  window.addItemToCart = addItemToCart;

  // Cart upsell A/B: "Add" buttons are static Liquid markup (not re-rendered),
  // so a one-time binding is enough. Adds the product as a ONE-TIME purchase
  // (no data-selling-plan-id → selling_plan: null; client request 2026-09-11);
  // addItemToCart re-renders the cart, which re-runs the upsell in-cart logic.
  document.querySelectorAll(".cart-upsell-add").forEach(function (btn) {
    btn.addEventListener("click", function () {
      addItemToCart(btn.dataset.variantId, 1, btn.dataset.sellingPlanId || null);
    });
  });

  // Cart upsell gallery (Swiper, fixed 260px slides). slidesOffsetBefore/After
  // mirror the drawer's px-4/md:px-6 padding — the swiper itself is bled to
  // the drawer edges with negative margins. observer/observeParents make it
  // re-measure when #cart-upsell (initially display:none) is shown and when
  // renderCart hides/unhides cards.
  // The slider only exists while 2+ cards are visible: renderCart destroys it
  // (and hides the arrows) when an upsell Add leaves a single card, and
  // re-creates it when removing a cart item brings a second card back.
  const cartUpsellTrack = document.querySelector(".cart-upsell-track");
  let cartUpsellSwiper = null;

  function initCartUpsellSwiper() {
    if (!cartUpsellTrack || !window.Swiper || cartUpsellSwiper) return;
    // the swiper provides the edge gaps via its offsets — drop the static fallback padding
    cartUpsellTrack.classList.remove("px-4", "md:px-6");
    cartUpsellSwiper = new Swiper(cartUpsellTrack, {
      slidesPerView: "auto",
      spaceBetween: 4,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      observer: true,
      observeParents: true,
      breakpoints: {
        768: { slidesOffsetBefore: 24, slidesOffsetAfter: 24 },
      },
    });
  }

  function destroyCartUpsellSwiper() {
    if (!cartUpsellSwiper) return;
    cartUpsellSwiper.destroy(true, true);
    cartUpsellSwiper = null;
    // static fallback: keep the edge gap the swiper offsets used to provide
    cartUpsellTrack.classList.add("px-4", "md:px-6");
  }

  initCartUpsellSwiper();
  document.querySelector(".cart-upsell-prev")?.addEventListener("click", function () {
    if (cartUpsellSwiper) cartUpsellSwiper.slidePrev();
  });
  document.querySelector(".cart-upsell-next")?.addEventListener("click", function () {
    if (cartUpsellSwiper) cartUpsellSwiper.slideNext();
  });

  // The header renders TWO .open-cart-menu buttons (desktop + mobile layouts),
  // so the counter must be written to every <i>, not just the first match.
  const headerCounters = document.querySelectorAll(".open-cart-menu i");
  const storedCount = localStorage.getItem("cartItemCount");

  headerCounters.forEach(function (counter) {
    counter.innerHTML = storedCount !== null ? storedCount : "0";
  });

  // ---- Brand-styled subscription-plan popup (cart drawer) ----
  // Replaces the native <select> with a centered modal listing the plans, the
  // selected one marked with a checkmark. Variant A still uses the <select>.
  const SUBSCRIPTION_CHECK_SVG = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 13L9.5 17.5L19 7" stroke="#2A312A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  function closeSubscriptionModal() {
    const modal = document.getElementById("subscription-modal");
    if (modal) modal.classList.add("hidden");
  }

  // Lazily create one shared modal element inside the cart drawer and reuse it.
  function getSubscriptionModal() {
    let modal = document.getElementById("subscription-modal");
    if (modal) return modal;

    const drawer = document.querySelector(".cart-menu-slideout");
    if (!drawer) return null;

    modal = document.createElement("div");
    modal.id = "subscription-modal";
    modal.className = "subscription-modal hidden absolute inset-0 z-50";
    modal.innerHTML = `
      <div class="subscription-modal-backdrop absolute inset-0"></div>
      <div class="subscription-modal-card absolute z-1 max-h-[calc(100%_-_32px)] overflow-y-auto bg-offWhite rounded-[20px] shadow-[0_12px_40px_rgba(42,49,42,0.18)] py-3" role="dialog" aria-modal="true" aria-label="Subscription Plans">
        <p class="subscription-modal-title text-center text-lightGrey text-sm leading-5 tracking-2% mb-1">Subscription Plans</p>
        <div class="subscription-modal-options"></div>
      </div>`;
    drawer.appendChild(modal);

    modal
      .querySelector(".subscription-modal-backdrop")
      .addEventListener("click", closeSubscriptionModal);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeSubscriptionModal();
    });

    return modal;
  }

  function openSubscriptionModal(trigger) {
    const modal = getSubscriptionModal();
    if (!modal) return;

    const plans = trigger._plans || [];
    const item = trigger._item;
    const selectedId = trigger.dataset.selectedId;
    const optionsWrap = modal.querySelector(".subscription-modal-options");

    optionsWrap.innerHTML = plans
      .map(
        (p) => `
        <button type="button" class="subscription-modal-option relative block w-full text-center py-4 px-12 text-deepGreen text-[15px] leading-5 tracking-2% rounded-xl cursor-pointer transition-colors duration-100 hover:bg-beige aria-selected:font-semibold" data-plan-id="${
          p.id
        }" aria-selected="${p.id === selectedId ? "true" : "false"}">
          <span class="subscription-modal-check absolute left-4 top-1/2 -translate-y-1/2 inline-flex items-center justify-center">${
            p.id === selectedId ? SUBSCRIPTION_CHECK_SVG : ""
          }</span>
          <span class="subscription-modal-option-label">${p.name}</span>
        </button>`
      )
      .join("");

    optionsWrap
      .querySelectorAll(".subscription-modal-option")
      .forEach((btn) => {
        btn.addEventListener("click", function () {
          const planId = btn.dataset.planId;
          closeSubscriptionModal();

          const newPlanId = planId === "null" ? null : planId;
          const itemKey = item.key;
          const quantityInput = document.querySelector(
            `.validateItemNumberInput[data-key="${itemKey}"]`
          );
          const quantity = quantityInput
            ? parseInt(quantityInput.value) || 1
            : 1;

          changeProductFromCart(item.id, itemKey, quantity, newPlanId);
        });
      });

    modal.classList.remove("hidden");

    // Anchor the popup directly under the trigger (same width) so it reads as
    // one continuous element with the selector instead of a centered modal.
    const drawer = document.querySelector(".cart-menu-slideout");
    const card = modal.querySelector(".subscription-modal-card");
    if (drawer && card) {
      const t = trigger.getBoundingClientRect();
      const d = drawer.getBoundingClientRect();
      card.style.top = `${t.bottom - d.top + 8}px`;
      card.style.left = `${t.left - d.left}px`;
      card.style.width = `${t.width}px`;
    }
  }

  async function renderCart(data) {
    const cartCount = document.getElementById("cart-count");
    cartCount.innerText = data.item_count;

    const emptyCart = document.getElementById("cart-empty");
    const cartContent = document.getElementById("cart-content");

    // Desktop + mobile header both have an .open-cart-menu counter
    document.querySelectorAll(".open-cart-menu i").forEach(function (counter) {
      counter.innerHTML = data.item_count;
    });

    localStorage.setItem("cartItemCount", data.item_count);

    if (data.item_count === 0) {
      emptyCart.classList.remove("hidden");
      cartContent.classList.add("hidden");
    } else {
      emptyCart.classList.add("hidden");
      cartContent.classList.remove("hidden");

      const cartItems = document.getElementById("cart-items");
      cartItems.innerHTML = "";

      const cartTotalContainer = document.getElementById("cart-total");
      const { originalTotal, discountedTotal } = calculateCartTotals(data);

      const affiliateCode = document.getElementById('affiliate-discount-code');

      if (window.cartState.isAffiliate) {
        affiliateCode.classList.remove('hidden');
      }

      let totalHtml = "";

      if (originalTotal !== discountedTotal) {
        totalHtml = `
          <span class="text-lightGrey line-through">$${originalTotal}</span>
          <span>$${discountedTotal}</span>   
        `;
      } else {
        totalHtml = `
          <span>$${discountedTotal}</span>   
        `;
      }

      cartTotalContainer.innerHTML = totalHtml;

      const subTotalCount = document.getElementById("subtotal-items");
      subTotalCount.innerHTML = `(${data.item_count} items)`;

      const btnTotal = document.getElementById("btn-total");
      btnTotal.innerHTML = `$${discountedTotal}`;

      //Render items
      data.items.forEach(function (item, index) {
        const hasPlan = item.hasOwnProperty("selling_plan_allocation");

        // --- Price / save / badge pieces ---
        let priceGroupB = "";
        let saveB = "";
        let badgeB = "";
        if (hasPlan) {
          priceGroupB = `
            <div class="flex gap-x-1.5 items-center shrink-0">
              <span class="text-lightGrey text-sm leading-6 tracking-2% line-through">$${(
                item.selling_plan_allocation.compare_at_price / 100
              ).toFixed(2)}</span>
              <span class="text-deepGreen text-[18px] leading-5 tracking-2%">$${(
                item.selling_plan_allocation.price / 100
              ).toFixed(2)}</span>
            </div>`;
          saveB = `<p class="text-lightGrey text-xs leading-4 tracking-2%">You save $${(
            (item.selling_plan_allocation.compare_at_price -
              item.selling_plan_allocation.price) /
            100
          ).toFixed(2)}</p>`;
          badgeB = `<span class="bg-orange text-deepGreen text-sm leading-5 tracking-2% px-1.5 py-0.5 rounded-lg">${
            item.selling_plan_allocation.selling_plan.price_adjustments[0].value
          }% OFF</span>`;
        } else {
          priceGroupB = `<span class="text-deepGreen text-[18px] leading-5 tracking-2% shrink-0">$${(
            item.price / 100
          ).toFixed(2)}</span>`;
        }

        fetchProductData(item.handle).then((productData) => {
          if (productData) {
            // The custom brand-styled popup renders from this structured plan
            // list. "One time" is ALWAYS the first option — subscription items
            // must be switchable back to a one-time purchase.
            const plans = [{ id: "null", name: "One time" }];
            productData.selling_plan_groups.forEach((group) => {
              if (group.app_id == "5859381") {
                group.selling_plans.forEach((plan) => {
                  plans.push({ id: String(plan.id), name: plan.name });
                });
              }
            });
            const selectedPlanId = item.selling_plan_allocation
              ? String(item.selling_plan_allocation.selling_plan.id)
              : "null";
            const selectedPlan =
              plans.find((p) => p.id === selectedPlanId) ||
              plans[0] || { id: "null", name: "One time" };

            // Custom popup trigger (brand-styled). The actual plan list opens
            // in a modal anchored under the trigger (see openSubscriptionModal).
            const subscriptionHTML = `
                <button type="button" class="subscription-dropdown-trigger relative flex items-center justify-between w-full border-[0.75px] border-deepGreen rounded-lg pl-4 pr-2 py-1.5 text-left" data-variant-id="${item.id}" data-key="${item.key}" data-selected-id="${selectedPlan.id}">
                  <span class="subscription-dropdown-label text-deepGreen text-sm leading-5 tracking-2% truncate pr-2">${selectedPlan.name}</span>
                  <svg class="shrink-0 pointer-events-none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M16.5962 10.5962L12.0001 15.1923L7.40395 10.5962" stroke="#2A312A" stroke-linecap="square"/>
                  </svg>
                </button>
              `;

            const subscriptionContainer = document.querySelector(
              `.subscription-select[data-product-index="${index}"]`
            );
            if (subscriptionContainer) {
              subscriptionContainer.innerHTML = subscriptionHTML;

              // Wire the brand popup. Plan data is stashed on the trigger
              // element so the shared modal can render it on click.
              const trigger = subscriptionContainer.querySelector(
                ".subscription-dropdown-trigger"
              );
              if (trigger) {
                trigger._plans = plans;
                trigger._item = item;
                trigger.addEventListener("click", function (e) {
                  e.stopPropagation();
                  openSubscriptionModal(trigger);
                });
              }
            }
          }
        });

        cartItems.innerHTML += `<div class="cart-item flex flex-col gap-y-5 pt-4 pb-8 border-b-[0.75px] border-[#8A7673]">
          <div class="flex gap-x-3 items-start">
            <div class="relative shrink-0 size-[90px]">
              <img class="size-[90px] rounded-[10px] object-cover" src="${item.image}" alt="${item.title}" />
              <button class="icon-cart-remove absolute -left-3 -top-2 z-1 flex items-center justify-center size-6 rounded-full bg-offWhite border border-lightPurple" data-delete-id='${item.key}' aria-label="Remove item">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L9 9M9 1L1 9" stroke="#2A312A" stroke-linecap="round"/></svg>
              </button>
            </div>
            <div class="flex flex-col grow min-w-0 items-end justify-center self-stretch gap-y-3">
              <div class="flex flex-col items-end w-full">
                <div class="flex items-center justify-between w-full gap-x-2">
                  <h4 class="text-black text-base leading-6 tracking-2% min-w-0 truncate">${item.title}</h4>
                  ${priceGroupB}
                </div>
                ${saveB}
              </div>
              <div class="flex items-center justify-between w-full">
                ${badgeB}
                <div class="flex items-center justify-between w-[90px] h-8 shrink-0 ml-auto">
                  <button class="decrementItemQuantity text-deepGreen focus:outline-none" type="button">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 12H21" stroke="#2A312A"/></svg>
                  </button>
                  <input type="text" data-variant-id="${item.id}" data-key="${item.key}" class="validateItemNumberInput w-8 text-base leading-6 text-center bg-transparent outline-none" value="${item.quantity}" min="1">
                  <button class="incrementItemQuantity text-deepGreen focus:outline-none" type="button">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 11H21" stroke="#2A312A"/><path d="M12 20L12 2" stroke="#2A312A"/></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="subscription-select w-full" data-product-index="${index}"></div>
        </div>`;
      });

      // ---- Cart upsell "Best Paired With" (permanent — the A/B test won) ----
      // Show only the catalog products NOT in the cart; hide the whole block
      // (via the `hidden` class on #cart-upsell and the cards) when every
      // product is already there.
      const cartUpsell = document.getElementById("cart-upsell");
      if (cartUpsell) {
        const cartProductIds = data.items.map((item) => String(item.product_id));
        let upsellVisible = 0;
        cartUpsell.querySelectorAll(".cart-upsell-card").forEach((card) => {
          const inCart = cartProductIds.includes(card.dataset.productId);
          card.classList.toggle("hidden", inCart);
          if (!inCart) upsellVisible++;
        });
        cartUpsell.classList.toggle("hidden", upsellVisible === 0);

        // a single card needs no slider: hide the arrows and tear the swiper
        // down (it comes back when a second card reappears)
        const upsellNav = cartUpsell.querySelector(".cart-upsell-nav");
        if (upsellNav) upsellNav.classList.toggle("hidden", upsellVisible < 2);
        if (upsellVisible < 2) {
          destroyCartUpsellSwiper();
        } else {
          initCartUpsellSwiper();
        }
      }

      //Delete item functionality
      let removeButtons = document.querySelectorAll(".icon-cart-remove");
      removeButtons.forEach(function (button) {
        if (!button) return;
        button.addEventListener("click", async function (e) {
          e.preventDefault();
          const variantId = button.dataset.deleteId;

          try {
            await deleteProductFromCart(variantId);
            initCart();
          } catch (error) {
            console.error("Error deleting product:", error);
          }
        });
      });

      // QTY functionality
      document.querySelectorAll(".cart-item").forEach((block) => {
        const decrementButton = block.querySelector(".decrementItemQuantity");
        const incrementButton = block.querySelector(".incrementItemQuantity");
        const inputField = block.querySelector(".validateItemNumberInput");

        if (!decrementButton || !incrementButton || !inputField) return;

        decrementButton.addEventListener("click", () => {
          let currentValue = parseInt(inputField.value) || 0;
          if (currentValue > 1) {
            inputField.value = currentValue - 1;

            let itemKey = inputField.dataset.key;

            changeProductQuantity(itemKey, inputField.value);
          }
        });

        incrementButton.addEventListener("click", () => {
          let currentValue = parseInt(inputField.value) || 0;
          inputField.value = currentValue + 1;

          let itemKey = inputField.dataset.key;

          changeProductQuantity(itemKey, inputField.value);
        });

        inputField.addEventListener("input", () => {
          inputField.value = inputField.value.replace(/[^0-9]/g, "");
          if (inputField.value === "" || parseInt(inputField.value) < 1) {
            inputField.value = 1;
          }

          let itemKey = inputField.dataset.key;

          changeProductQuantity(itemKey, inputField.value);
        });
      });
    }
  }

  function calculateCartTotals(cartData) {
    let originalTotal = 0;
    let discountedTotal = 0;

    cartData.items.forEach((item) => {
      if (item.selling_plan_allocation) {
        originalTotal +=
          item.selling_plan_allocation.compare_at_price * item.quantity;
        discountedTotal += item.selling_plan_allocation.price * item.quantity;
      } else {
        originalTotal += item.original_line_price;
        discountedTotal += item.final_line_price;
      }
    });

    return {
      originalTotal: (originalTotal / 100).toFixed(2),
      discountedTotal: (discountedTotal / 100).toFixed(2),
    };
  }

  function fetchProductData(productHandle) {
    return fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Network response was not ok: ${response.statusText}`
          );
        }
        return response.json();
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
        alert(`Error fetching product data: ${error.message}`);
        return null;
      });
  }

  function initCart() {
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        window.cartData = data;
        renderCart(data);
      })
      .catch((error) => {
        console.log("Error: " + error.message);
      });
  }

  async function changeProductFromCart(
    variantId,
    itemKey,
    qty,
    sellingPlan = null
  ) {
    console.log(
      "Variant ID:",
      variantId,
      "Item Key:",
      itemKey,
      "Quantity:",
      qty,
      "Selling Plan:",
      sellingPlan
    );

    try {
      await updateProductWithSubscription(itemKey, qty, sellingPlan);

      initCart();
    } catch (error) {
      console.error("Error in changeProductFromCart:", error);
    }
  }

  function deleteProductFromCart(itemKey) {
    return new Promise((resolve, reject) => {
      const data = {
        id: itemKey,
        quantity: 0,
      };

      postAjax(
        "/cart/change.js",
        data,
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  function addProductToCart(variantId, qty) {
    return new Promise((resolve, reject) => {
      const data = {
        id: variantId,
        quantity: qty,
      };

      postAjax(
        "/cart/add.js",
        data,
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  function updateProductWithSubscription(itemKey, qty, sellingPlan) {
    return new Promise((resolve, reject) => {
      const data = {
        id: itemKey,
        quantity: qty,
        selling_plan: sellingPlan,
      };

      postAjax(
        "/cart/change.js",
        data,
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  function changeProductQuantity(itemKey, qty) {
    const data = {
      id: itemKey,
      quantity: qty,
    };

    postAjax(
      "/cart/change.js",
      data,
      (response) => {
        console.log("Quantity updated successfully:", response);
        initCart();
      },
      (error) => {
        console.error("Error updating quantity:", error);
      }
    );
  }

  function postAjax(url, data, successCallback, errorCallback) {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        const response = JSON.parse(xhr.responseText);
        if (successCallback) successCallback(response);
      } else {
        if (errorCallback) errorCallback(xhr.statusText);
      }
    };

    xhr.onerror = function () {
      if (errorCallback) errorCallback(xhr.statusText);
    };

    xhr.send(JSON.stringify(data));
  }

  const cartIconOpen = document.querySelector(".open-cart-menu");
  const cartIconClose = document.querySelector(".close-cart-menu");
  const cartMenu = document.querySelector(".cart-menu-slideout");
  const bodyCartMenu = document.body;

  const openCartMenu = () => {
    cartMenu.classList.add("active");
    bodyCartMenu.classList.add("overflow-hidden", "body-overlay");
    // Move screen reader focus to the Cart heading when drawer opens (accessibility)
    requestAnimationFrame(() => {
      const heading = document.getElementById("cart-drawer-heading");
      if (heading) heading.focus({ preventScroll: true });
    });
  };

  const closeCartMenu = () => {
    cartMenu.classList.remove("active");
    bodyCartMenu.classList.remove("overflow-hidden", "body-overlay");
  };

  if(cartMenu) {
    const handleBodyClick = (event) => {
      const isClickInsideMenu = cartMenu.contains(event.target);
      const isClickOnOpenButton = event.target.closest(".open-cart-menu");

      if (isClickOnOpenButton) {
        openCartMenu();
      } else if (!isClickInsideMenu) {
        closeCartMenu();
      }
    };
    bodyCartMenu.addEventListener("click", handleBodyClick);
  }
  if(cartIconClose) {
    cartIconClose.addEventListener("click", (event) => {
      event.stopPropagation();
      closeCartMenu();
    });
  }

  let current_url = location.href;
  let url = new URL(current_url);
  let viewcart = url.searchParams.get("viewcart");
  if (viewcart == "true") {
    setTimeout(function () {
      openCartMenu();
      initCart();
    }, 700);
  }

  // header-new has TWO cart buttons (desktop + mobile) — bind them all,
  // otherwise the mobile one only opens the drawer (via the body click
  // handler) without fetching/rendering the cart
  document.querySelectorAll(".open-cart-menu").forEach(function (openCartButton) {
    openCartButton.addEventListener("click", function () {
      openCartMenu();
      initCart();
    });
  });
});

window.cartState = window.cartState || { isAffiliate: false, ready: Promise.resolve() };

window.cartState.ready = fetch("/cart.js")
  .then(r => {
    if (!r.ok) throw new Error("Network response was not ok");
    return r.json();
  })
  .then(data => {
    console.log(data);
    window.cartState.isAffiliate = (data.discount_codes || []).some(
      d => d.code === "BODIPARTNER"
    );
  })
  .catch(err => {
    console.log("Error:", err.message);
    window.cartState.isAffiliate = false;
  });

(async () => {
  await window.cartState.ready;

  const bar = document.getElementById("affiliate-bar");
  const pdpBar = document.getElementById("affiliate-pdp-bar");

  if (!bar) return;

  if (window.cartState.isAffiliate) {
    bar.classList.remove("hidden");
    pdpBar.classList.remove("hidden");
    document.getElementById('one-time')?.click();
  }
})();